<template>
  <AppLayout
    :is-initialized="isInitialized"
    :error="error"
  >
    <template
      v-if="isCardDisabled"
      #banner
    >
      <TheCardOff />
    </template>
    <template #header>
      <TheHeader />
    </template>
    <template #navbar>
      <TheNavbar />
    </template>
    <template #main>
      <section class="page__container">
        <RouterView v-slot="{ Component, route }">
          <transition
            :name="route.meta.transition || 'fade'"
            mode="out-in"
          >
            <component :is="Component" />
          </transition>
        </RouterView>
      </section>
    </template>
    <template #footer>
      <TheCall v-if="!isCardDisabled" />
      <TheFooter />
      <AppToast />
      <AppConfirmDialog />
      <BaseDialog
        v-model="showSmsModal"
        close
        content-width="1655px"
      >
        <SmsWrongBonusDialog />
      </BaseDialog>
    </template>
  </AppLayout>
</template>

<script>
import App from '@/shared/components/App.vue';
import AppLayout from '@/shared/components/layout/AppLayout.vue';
import TheFooter from '@/projects/mti/components/TheFooter/TheFooter.vue';
import TheHeader from '@/projects/mti/components/TheHeader/TheHeader.vue';
import TheNavbar from '@/projects/mti/components/TheNavbar/TheNavbar.vue';
import TheCardOff from '@/projects/mti/components/TheCardOff/TheCardOff.vue';
import TheCall from '@/projects/mti/components/TheCall/TheCall.vue';
import AppToast from '@/shared/components/AppToast/AppToast.vue';
import AppConfirmDialog from '@/shared/components/AppConfirmDialog/AppConfirmDialog.vue';
import AppInfoDialog from '@/shared/components/AppInfoDialog/AppInfoDialog.vue';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import SmsWrongBonusDialog from '@/projects/mti/components/popups/SmsWrongBonusDialog/SmsWrongBonusDialog.vue';
import { needToShowWelcomeSmsModal } from '@/shared/lib/welcomeBonus/application';
import { useUserStore } from '@/shared/store/useUserStore';

export default {
  name: 'App',
  components: {
    SmsWrongBonusDialog,
    BaseDialog,
    AppInfoDialog,
    AppToast,
    AppLayout,
    AppConfirmDialog,
    TheFooter,
    TheHeader,
    TheCardOff,
    TheNavbar,
    TheCall,
  },
  extends: App,
  data() {
    return {
      showSmsModal: false,
    };
  },
  methods: {
    afterCommonsFetched() {
      const userStore = useUserStore();
      if (userStore.getUserInfo?.phones?.[0]) {
        needToShowWelcomeSmsModal(
          userStore.getUserInfo.phones[0],
        ).then(showSmsSentModal => {
          this.showSmsModal = showSmsSentModal;
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/shared/assets/styles/App.scss";
@import "@/projects/mti/assets/styles/App.scss";
</style>
